export default {
  seo: {
    home: {
      title: "IGNIVA — Surfaces and solutions for architecture and interiors",
      desc: "IGNIVA selects and represents international brands of materials, surfaces and technology for architecture and interiors. Lithotech, in exclusive distribution in Portugal by IGNIVA.",
    },
    about: {
      title: "About IGNIVA — Curation, technical support and commercial follow-up | IGNIVA",
      desc: "IGNIVA selects brands and materials, supports specification and works with architects, designers, kitchen and bath studios, stone fabricators and furniture makers.",
    },
    brands: {
      title: "Brands & solutions | IGNIVA",
      desc: "Lithotech, Foster and Mastercharge: large-format surfaces, kitchen equipment and integrated wireless charging.",
    },
    applications: {
      title: "Applications — Kitchens, bathrooms, furniture and cladding | IGNIVA",
      desc: "Applications in kitchens, bathrooms, furniture, cladding, façades and integrated technology, with the brands presented by IGNIVA.",
    },
    explorer: {
      title: "Explore solutions | IGNIVA",
      desc: "Discover surfaces and solutions by brand, application and feature, and request information with the context already set.",
    },
    professionals: {
      title: "Professionals — Architects, designers, kitchen and bath | IGNIVA",
      desc: "Information, official documentation and specification support for architects, designers, kitchen and bath studios, stone fabricators and furniture makers.",
    },
    contacts: {
      title: "Contact | IGNIVA",
      desc: "Tell us about your project: product information, samples, documentation or a quotation.",
    },
    quote: {
      title: "Quotation request | IGNIVA",
      desc: "Request a quotation: brand, application and project details. Prices depend on validation of measurements, materials and technical details.",
    },
    privacy: { title: "Privacy policy | IGNIVA", desc: "How IGNIVA handles personal data collected through this website." },
    legal: {
      title: "Legal information | IGNIVA",
      desc: "Company identification of IGNIVA Design & Surface Solutions, Unipessoal Lda.",
    },
  },
  nav: {
    home: "Home",
    about: "About",
    brands: "Brands",
    applications: "Applications",
    explorer: "Explore solutions",
    professionals: "Professionals",
    contacts: "Contact",
    quote: "Request a quote",
    menu_open: "Open menu",
    menu_close: "Close menu",
  },
  common: {
    all: "All",
    all_m: "All",
    explore: "Explore",
    request_info: "Request information",
    request_quote: "Request a quote",
    next: "Next",
    back: "Back",
    submit: "Submit request",
    sending: "Sending…",
    close: "Close",
    official_site: "Official brand website",
    catalogue: "Catalogues and documentation",
    catalogue_note: "Catalogues, technical sheets and samples depend on each brand. Talk to IGNIVA to find out what is available.",
    applications: "Applications",
    brand: "Brand",
    aesthetic: "Feature",
    step: "Step",
    of: "of",
    origin: "Origin",
    scopes: "Applications",
    back_brands: "Back to brands",
    gallery: "Applications and inspiration",
    categories: "Products and solutions",
    video: "Official video",
    video_hint: "Play the brand's official video (YouTube)",
    video_note: "When played, the video is loaded from YouTube, which may store cookies in your browser.",
    docs: "Official documentation",
    image_note: "Official brand photography, used as application or inspiration. It does not show projects carried out by IGNIVA.",
    pending_image: "Official image coming soon",
    brands_label: "Brands",
    exclusive_pt: "Exclusive distribution in Portugal by IGNIVA",
    know_brand: "Discover {name}",
  },
  home: {
    tag: "Architecture · Interiors · Surfaces",
    h1a: "Surfaces and solutions",
    h1b: "for projects with identity.",
    intro: "IGNIVA selects and represents international brands of materials, surfaces and technology for architecture and interiors.",
    cta1: "Discover the brands",
    cta2: "Tell us about your project",
    slides: [
      { a: "Kitchens", b: "Lithotech — kitchen composition" },
      { a: "Worktops", b: "Lithotech — worktop detail" },
      { a: "Surfaces", b: "Lithotech — surface finish" },
    ],
    trust: [
      "Careful selection of brands and materials",
      "Technical and specification support",
      "A link between manufacturers and professionals",
    ],
    scroll: "Scroll to discover",
    manifesto_tag: "What we do",
    manifesto_title: "Between those who make and those who design.",
    manifesto_text: [
      "IGNIVA brings international brands closer to architecture and interior design professionals.",
      "We select materials and solutions for their quality, design and technical performance, supporting architects, designers, kitchen studios, manufacturers and fabricators in integrating them into each project.",
      "Our work combines knowledge of materials, specification support and commercial follow-up.",
    ],
    manifesto_cta: "About IGNIVA",
    roles: [
      {
        t: "Selection",
        d: "We select brands and materials for their aesthetic quality, technical performance and range of applications.",
      },
      {
        t: "Specification support",
        d: "We support professionals in choosing materials and solutions, providing technical information and the manufacturers' official documentation.",
      },
      {
        t: "Commercial follow-up",
        d: "We link manufacturers and professionals, following up information requests, specification and the development of opportunities.",
      },
    ],
    sectors_tag: "Who for",
    sectors: ["Architecture", "Interior design", "Kitchen and bath", "Stone fabricators", "Furniture", "Developers"],
    brands_tag: "Brands",
    brands_title: "Brands and solutions",
    brands_sub: "International brands with distinct proposals for architecture, interiors and furniture. Materials, equipment and technology selected for their characteristics and range of applications.",
    apps_tag: "Applications",
    apps_title: "Where each solution applies.",
    apps_cta: "See all applications",
    explorer_tag: "Discovery",
    explorer_title: "Explore solutions",
    explorer_text: "Discover materials and solutions by brand, application and features, and find the information most relevant to your project.",
    explorer_cta: "Open the explorer",
    cta_title: "Tell us about your project.",
    cta_text: [
      "Looking for information on materials, equipment or solutions for a project?",
      "Contact us to request technical documentation, samples or a quotation.",
    ],
    intro2: "We support architects, designers and other professionals in choosing and specifying solutions for kitchens, bathrooms, furniture and cladding.",
    apps_intro: "Materials, equipment and technology for different spaces and project needs.",
  },
  about: {
    tag: "About IGNIVA",
    title: "Between those who make and those who design.",
    lead: "IGNIVA curates surfaces and solutions for architecture and interiors, with close technical and commercial support for professionals. We select brands and materials, help with specification and follow each request closely.",
    experience: "The company builds on its founder's experience in the stone and surfaces sector, with a background in commercial management, market development and working with professional networks.",
    note: "IGNIVA is neither a manufacturer nor an installer.",
    note_text: "Product characteristics belong to each brand and are set out in its official documentation. IGNIVA takes care of selection, specification support and commercial follow-up.",
    pillars_tag: "How we work",
    pillars_title: "Three ways to support your project.",
    pillars: [
      {
        n: "01",
        t: "Selection",
        d: "We choose brands and materials for their aesthetic and technical quality and for how they fit into projects.",
      },
      {
        n: "02",
        t: "Specification support",
        d: "We help you understand the material, its applications and each brand's official documentation, so the choice is an informed one.",
      },
      {
        n: "03",
        t: "Commercial follow-up",
        d: "We connect brands and professionals, with close contact from the very first request for information.",
      },
    ],
    rel_tag: "Who for",
    rel_title: "Who we work with.",
    rel_text: "Architects and interior designers, kitchen and bath shops and studios, stone fabricators, furniture makers and developers of residential, commercial and Hospitality projects. We speak the technical language of those who specify, clearly enough for those who decide.",
    cta: "Tell us about your project",
  },
  brands_page: {
    tag: "Brands",
    title: "Brands and solutions",
    sub: "International brands with distinct proposals for architecture, interiors and furniture. Materials, equipment and technology selected for their characteristics and range of applications.",
    filter_all: "All",
    cta: "View brand",
  },
  brand: {
    lithotech: {
      tag: "Sintered stone",
      origin: "Castellón, Spain",
      headline: "Large-format surfaces.",
      categories: ["Kitchen worktops", "Bathrooms", "Furniture", "Cladding"],
      short: "Large-format sintered stone surfaces for worktops, cladding, furniture and other architectural applications. A selection of colours, textures and finishes that combines aesthetic expression, technical performance and versatility of application.",
      long: [
        "Lithotech is a Spanish sintered stone brand, headquartered and producing in Castellón. Its collections include Frame, Oda, Gubi and Allure, among others.",
        "The brand develops its own technology, such as Corelith® and 3D·Fit®, for surfaces with relief and controlled sintering. The Frame, Oda and Gubi collections use 3D·Fit® to match the pattern to the surface relief.",
        "IGNIVA is the exclusive distributor of Lithotech in Portugal. Formats, thicknesses, finishes and technical characteristics of each collection are set out in the official catalogue and data sheets.",
      ],
      ambitos: ["Kitchen worktops", "Bathrooms", "Furniture", "Cladding"],
      desc: [
        "Large-format sintered stone surfaces for worktops, cladding, furniture and other architectural applications.",
        "A selection of colours, textures and finishes that combines aesthetic expression, technical performance and versatility of application.",
      ],
    },
    foster: {
      tag: "Kitchen equipment",
      origin: "Brescello, Italy",
      headline: "Sinks and taps for the kitchen.",
      categories: ["Sinks", "Taps"],
      short: "Stainless steel kitchen equipment, developed with particular attention to design, functionality and integration into spaces. Sinks, taps, hobs and other solutions that combine technology and Italian design.",
      long: [
        "Foster is an Italian company founded in 1973, headquartered in Brescello with four production plants. It works stainless steel (AISI 304 and AISI 316) in sinks, taps and other kitchen equipment.",
        "The brand's finishes include satin steel and PVD colours such as Gun Metal, Gold and Copper. For information on ranges and finishes, talk to IGNIVA or visit the brand's official website.",
      ],
      ambitos: ["Kitchens"],
      desc: [
        "Stainless steel kitchen equipment, developed with particular attention to design, functionality and integration into spaces.",
        "Sinks, taps, hobs and other solutions that combine technology and Italian design.",
      ],
    },
    mastercharge: {
      tag: "Integrated wireless charging",
      origin: "United Kingdom",
      headline: "Your phone charges as you place it on the worktop.",
      categories: ["Charging under worktops", "Charging in furniture and tables"],
      short: "Wireless charging technology integrated beneath compatible surfaces, allowing devices to charge without chargers or cables visible on the worktop. A discreet solution for kitchens, tables and furniture that adds functionality without compromising design.",
      long: [
        "Mastercharge develops wireless (Qi) chargers to be installed underneath worktops, tables and furniture, with nothing visible. Simply place the phone on the surface to start charging.",
        "Charging works through materials such as wood, stone and glass, but not through metal. Maximum distance, power and compatibility depend on the model and the material: read the official manual and talk to IGNIVA before specifying.",
      ],
      ambitos: ["Kitchen worktops", "Furniture and tables"],
      desc: [
        "Wireless charging technology integrated beneath compatible surfaces, allowing devices to charge without chargers or cables visible on the worktop.",
        "A discreet solution for kitchens, tables and furniture that adds functionality without compromising design.",
      ],
    },
  },
  apps_page: {
    tag: "Applications",
    title: "Where each solution applies.",
    sub: "Choose an application to see the matching brands and solutions. Images are official brand photographs, used as application or inspiration.",
    brands_for: "Brands for this application",
  },
  app_items: {
    cozinhas: "Kitchens",
    banhos: "Bathrooms",
    mobiliario: "Furniture",
    revestimentos: "Cladding",
    fachadas: "Façades",
    integrada: "Integrated technology",
  },
  app_cats: {
    cozinhas: "Kitchens",
    banhos: "Bathrooms",
    mobiliario: "Furniture",
    revestimentos: "Cladding",
    fachadas: "Façades",
    integrada: "Integrated technology",
  },
  categories: { superficies: "Surfaces", equipamento: "Kitchen equipment", tecnologia: "Integrated technology" },
  explorer: {
    tag: "Discovery",
    title: "Explore solutions",
    sub: "Filter by brand, category, application and feature.",
    filter_brand: "Brand",
    filter_app: "Application",
    filter_aes: "Feature",
    filter_cat: "Category",
    empty: "No solution matches the selected filters.",
    detail_cta: "Request information",
    detail_brand: "Brand",
  },
  explorer_items: {
    "lithotech-superficies": {
      name: "Lithotech surfaces",
      desc: "Large-format surfaces for kitchen worktops, bathrooms and furniture, according to the technical documentation of each product.",
    },
    "lithotech-revestimentos": {
      name: "Large-format cladding",
      desc: "Large format for interior cladding, depending on the product and the brand's official documentation.",
    },
    "foster-lava-loucas": { name: "Foster sinks", desc: "Stainless steel sinks for the kitchen." },
    "foster-torneiras": { name: "Foster taps", desc: "Kitchen taps in different finishes." },
    "mastercharge-carregamento": {
      name: "Integrated wireless charging",
      desc: "Wireless charging integrated into worktops, tables and furniture. Compatibility depends on the brand's technical documentation.",
    },
  },
  aesthetics: { pedra: "Stone", aco: "Stainless steel", integrado: "Integrated", grande_formato: "Large format" },
  quote: {
    tag: "Quotation",
    title: "Quotation request",
    sub: "Four simple steps. Prices depend on validation of measurements, materials and technical details, so we reply after analysing your request.",
    steps: ["Brand", "Application", "Project", "Contact"],
    s1_title: "Which brand are you interested in?",
    s2_title: "Which application?",
    s3_title: "About the project",
    tipo: "Project type",
    quantidade: "Estimated quantity (m², units…)",
    localizacao: "Project location",
    tipos: {
      residencial: "Residential",
      hospitality: "Hospitality",
      comercial: "Commercial",
      retalho: "Retail",
      outro: "Other",
    },
    files_hint: "Have plans or technical files? After sending the request, send them to",
    s4_title: "Your contact details",
    review: "Request summary",
    new: "New request",
  },
  pros: {
    tag: "Professionals",
    title: "Solutions for those who design and transform.",
    sub: [
      "We work with architects, designers, kitchen and bath studios, stone fabricators, furniture manufacturers and developers.",
      "We provide information on materials, technical documentation and commercial support to make it easier to choose and integrate solutions in each project.",
    ],
    benefits_tag: "How we help",
    benefits_title: "Working with IGNIVA",
    benefits: [
      "A considered selection of brands and materials",
      "Official brand documentation to support specification",
      "Samples, whenever the brand makes them available",
      "One point of contact for information and quotation requests",
    ],
    res_tag: "Resources",
    res_title: "Documentation by brand",
    res_note: "Catalogues, technical sheets and samples depend on each brand. You can consult the public official documentation or ask us for information.",
    res_site: "Official website",
    res_docs: "Catalogues and documentation",
    form_tag: "Professional enquiry",
    form_title: "Introduce yourself to IGNIVA",
    tipo: "Professional profile",
    tipos: {
      arquiteto: "Architect",
      designer: "Interior designer",
      estudio_cozinhas: "Kitchen and bath shop or studio",
      marmorista: "Stone fabricator",
      fabricante: "Furniture maker",
      promotor: "Developer",
      outro: "Other",
    },
    areas: [
      {
        t: "Technical information",
        d: "Access to the manufacturers' official documentation, material characteristics and application recommendations.",
      },
      {
        t: "Samples and materials",
        d: "Support in identifying references and requesting samples for evaluation and specification.",
      },
      {
        t: "Commercial follow-up",
        d: "Coordination with manufacturers and partners to answer information requests and develop project opportunities.",
      },
    ],
  },
  contact: {
    tag: "Contact",
    title: "Tell us about your project.",
    sub: "Product information, samples, documentation or a quotation: tell us what you are looking for and we will reply by email.",
    assunto: "Type of request",
    assuntos: { info: "Information", amostras: "Samples", orcamento: "Quotation", outro: "Other" },
    email_label: "Email",
    phone_label: "Phone",
    form_title: "Send your message",
  },
  form: {
    nome: "Name",
    empresa: "Company",
    email: "Email",
    telefone: "Phone (optional)",
    atividade: "Professional activity",
    mensagem: "Message",
    atividades: [
      "Architecture",
      "Interior design",
      "Kitchen and bath shop or studio",
      "Stone fabricator",
      "Furniture maker",
      "Developer or commercial projects",
      "Private client",
      "Other",
    ],
    gdpr: "I authorise the processing of my data to reply to this request, under the",
    gdpr_link: "Privacy policy",
    send: "Send message",
    required: "Required field",
    success_title: "Thank you for getting in touch.",
    success_text: "We have received your request and will contact you as soon as possible.",
    error: "Your request could not be sent. Please try again or contact us at {email}.",
    another: "Send another request",
  },
  privacy: {
    tag: "Privacy",
    title: "Privacy policy",
    updated: "The legal text is available in Portuguese and is subject to final validation by IGNIVA before publication.",
  },
  footer: {
    tagline: "Selection and representation of international brands of materials, surfaces and technology for architecture and interiors.",
    nav: "Navigation",
    brands: "Brands",
    contact: "Contact",
    rights: "All rights reserved.",
    privacy: "Privacy policy",
    legal_info: "Legal information",
  },
  legal: {
    tag: "Legal information",
    title: "Company identification",
    intro: "Information provided under Article 10 of Portuguese Decree-Law 7/2004 (information society services).",
    name: "Company name",
    nif: "Tax ID (NIF / NIPC)",
    seat: "Registered office",
    email: "Email",
  },
};
